import type { Multilingual } from "../types";

export const getLocalizedString = (
  multilingual: Multilingual | null | undefined,
  lang: string = "en",
): string => {
  if (!multilingual) return "";
  const key = lang as keyof Multilingual;
  return (
    (multilingual[key]?.length ? multilingual[key] : null) ??
    (multilingual.en?.length ? multilingual.en : null) ??
    (multilingual.fr?.length ? multilingual.fr : null) ??
    (multilingual.es?.length ? multilingual.es : null) ??
    ""
  );
};
